"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithUserPersonal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _state = require("../state");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var WithUserPersonal = function WithUserPersonal(_ref) {
  var children = _ref.children,
    _ref$provided = _ref.provided,
    provided = _ref$provided === void 0 ? true : _ref$provided,
    path = _ref.path,
    homePath = _ref.homePath,
    loginPath = _ref.loginPath,
    requiredFields = _ref.requiredFields;
  var _useUser = (0, _state.useUser)(),
    user = _useUser.user;
  if (!user) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: loginPath
    });
  }
  var emptyPersonal = requiredFields.filter(function (c) {
    return !(user !== null && user !== void 0 && user.personal[c]);
  });
  if (provided && emptyPersonal.length) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: path
  });
  if (!provided && !emptyPersonal.length) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: homePath
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
exports.WithUserPersonal = WithUserPersonal;